/**
 * External Links
 * @enum
 */
const Links = {
  CONTACT_US: 'https://www.ampol.com.au/support/get-in-touch', 
  SUPPORT: 'https://www.ampol.com.au/support/frequently-asked-questions',
  PRIVACY: 'https://www.ampol.com.au/privacy-policy',
  PRIVACY_AND_REPORTING_POLICY: 'https://www.ampol.com.au/privacy-policy', // temporarily replace this dead link TASK-23275 'https://ampol.com.au/privacy-and-reporting-policy',
  AMPOL: 'http://www.ampol.com.au/',

  LOYALTY_PROGRAM_REWARDS_SCHEME: 'https://www.ampol.com.au/ampolcardandwrtandc.pdf',
  WOOLWORTHS_REWARDS: 'https://www.woolworthsrewards.com.au/terms.html',
  MY_AMPOL_LOGIN: 'https://my.ampol.com.au/Login.aspx',
  AMPOL_CARD_EMAIL: 'mailto:ampolcard@ampol.com.au',

};

export default Links;